import { Link } from 'react-router-dom';

interface HeroSectionProps {
  scrollY: number;
}

const HeroSection = ({ scrollY }: HeroSectionProps) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/c26050cbf628756734c2e6696121d5dc.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transform: `translateY(${scrollY * 0.5}px)`,
        }}
      ></div>

      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-slate-900/50 to-slate-900"></div>

      <div className="absolute top-20 left-10 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>

      <div className="relative z-10 px-6 lg:px-12 py-32 max-w-7xl mx-auto text-center">
        <div className="mb-8 inline-flex items-center space-x-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
          <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
          <span className="text-sm text-white font-medium">Trusted International Partner</span>
        </div>

        <h1 className="text-3xl lg:text-4xl font-bold text-white mb-6 leading-tight uppercase">
          Lynora — International Supply of
          <span className="block mt-2 bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
            Electronic Components
          </span>
          <span className="block mt-2">& Technical Solutions</span>
        </h1>

        <p className="text-lg text-slate-300 mb-12 max-w-3xl mx-auto leading-relaxed uppercase">
          Reliable wholesale distribution of electronic components, spare parts, and technical products with comprehensive international logistics support for European and Ukrainian markets.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
          <Link
            to="/contact"
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-lg font-semibold rounded-lg border-2 border-white/30 hover:bg-white/20 hover:scale-105 transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            Contact Us
          </Link>
        </div>

        <div className="mt-20 grid grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="w-24 h-24 mx-auto mb-4 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-2xl flex items-center justify-center shadow-lg">
              <i className="ri-cpu-line text-white text-4xl"></i>
            </div>
            <h3 className="text-white font-semibold mb-1">Electronic Components</h3>
            <p className="text-slate-400 text-sm">Import & Wholesale</p>
          </div>

          <div className="text-center">
            <div className="w-24 h-24 mx-auto mb-4 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-2xl flex items-center justify-center shadow-lg">
              <i className="ri-global-line text-white text-4xl"></i>
            </div>
            <h3 className="text-white font-semibold mb-1">EU & Ukraine Distribution</h3>
            <p className="text-slate-400 text-sm">Wide Network</p>
          </div>

          <div className="text-center">
            <div className="w-24 h-24 mx-auto mb-4 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-2xl flex items-center justify-center shadow-lg">
              <i className="ri-tools-line text-white text-4xl"></i>
            </div>
            <h3 className="text-white font-semibold mb-1">Technical Spare Parts</h3>
            <p className="text-slate-400 text-sm">Quality Supply</p>
          </div>

          <div className="text-center">
            <div className="w-24 h-24 mx-auto mb-4 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-2xl flex items-center justify-center shadow-lg">
              <i className="ri-truck-line text-white text-4xl"></i>
            </div>
            <h3 className="text-white font-semibold mb-1">International Logistics</h3>
            <p className="text-slate-400 text-sm">Full Support</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl opacity-50"></i>
      </div>
    </section>
  );
};

export default HeroSection;
